import { 
  Wallet, 
  Scale, 
  Laptop2, 
  ShieldCheck, 
  ClipboardList, 
  Database, 
  Users,
  Building2,
  Briefcase,
  UserCog,
  Brain,
  LineChart,
  Settings,
  FileText,
  UserCheck,
  Network,
  Globe,
  BookOpen,
  Microscope,
  Lightbulb,
  Target
} from 'lucide-react';

export const roleIconMap = {
  'Financial Manager': Wallet,
  'Dispute Auditor': Scale,
  'IT Manager': Laptop2,
  'Admin': ShieldCheck,
  'Operations Manager': ClipboardList,
  'Data Manager': Database,
  'Organizers Supervisor': Users,
  'Facilities Manager': Building2,
  'HR Manager': Briefcase,
  'System Administrator': UserCog,
  'Strategic Planner': Brain,
  'Analytics Manager': LineChart,
  'Technical Supervisor': Settings,
  'Documentation Manager': FileText,
  'Compliance Officer': UserCheck,
  'Network Manager': Network,
  'International Relations': Globe,
  'Training Manager': BookOpen,
  'Quality Assurance': Microscope,
  'Innovation Manager': Lightbulb,
  'Project Manager': Target
};